module.exports = __webpack_public_path__ + "static/1213656551.5a8893eb.jpg";